export default __webpack_public_path__ + "static/Fall7-de830b58e0533cef49b7735b585a2225.mp3";